import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { FileDown, AlertCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

/**
 * ExportPanel - Now redirects to Emergency Binder Summary for exports
 * 
 * All medical data is now centralized in the Emergency Binder using
 * the Single Source of Truth architecture. PDF exports and sharing
 * should be done from the Emergency Summary page.
 */
const ExportPanel = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center gap-3 p-4 bg-blue-50 rounded-lg border border-blue-100">
      <div className="flex items-center gap-2 text-blue-700">
        <AlertCircle className="h-5 w-5" />
        <span className="text-sm font-medium">Export moved to Emergency Binder</span>
      </div>
      <p className="text-xs text-blue-600 text-center max-w-xs">
        PDF exports and sharing are now available in the Emergency Binder Summary page, 
        which includes all your medical information in one place.
      </p>
      <Button 
        variant="outline" 
        size="sm"
        onClick={() => navigate('/emergency-binder')}
        className="gap-2 bg-white"
      >
        <FileDown className="h-4 w-4" />
        Go to Emergency Binder
      </Button>
    </div>
  );
};

export default ExportPanel;
